import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'nest-alert',
  styleUrl: 'nest-alert.scss',
  shadow: true,
})
export class NestAlert {
  /**
   * DUUUUUUUUU
   */
  @Prop() type: 'info' | 'success' | 'warning' | 'error';

  render() {
    const { type } = this;

    return (
      <Host>
        <div class={{
          'nest-alert': true,
          'nest-alert--info': type === 'info',
          'nest-alert--success': type === 'success',
          'nest-alert--warning': type === 'warning',
          'nest-alert--error': type === 'error',
        }}>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
